import React from "react";
import "./css/Aboutus.css";
import Slider from "react-slick";
import img2 from "./imgs/1.png"; // Adjust image import as needed
import th from "./imgs/th.jpeg"; // Adjust image import as needed
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

const people = [
  {
    name: "Joshua Mugisha",
    role: "Founder / CEO",
    imageUrl: img2,
  },
  {
    name: "Delice Marume",
    role: "Co-Founder",
    imageUrl: th,
  },
  {
    name: "Kevin Hirwa",
    role: "Co-Founder",
    imageUrl: th,
  },
  {
    name: "Charles Dushime",
    role: "Co-Founder",
    imageUrl: th,
  },
];

export default function Aboutus() {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1, // Show only one card at a time
    slidesToScroll: 1, // Scroll one card at a time
    draggable: true, // Enable dragging
    swipeToSlide: true, // Swipe to slide
    centerMode: true, // Center the active slide
    centerPadding: "30px", // Space on the sides of the center card
  };

  // typing text effects 
    const fullText = "You Wanna Know About Us ? 😉 ";
    const [displayText, setDisplayText] = useState("");
    const [isDeleting, setIsDeleting] = useState(false);
    const [charIndex, setCharIndex] = useState(0);

    useEffect(() => {
      const typingSpeed = isDeleting ? 50 : 100;
      const pauseDuration = 1000;

      // Set up the typing and deleting effect
      const typeEffect = setTimeout(() => {
        if (isDeleting) {
          // Deleting characters
          if (charIndex > 0) {
            setDisplayText(fullText.slice(0, charIndex - 1));
            setCharIndex(charIndex - 1);
          } else {
            setIsDeleting(false);
          }
        } else {
          // Typing characters
          if (charIndex < fullText.length) {
            setDisplayText(fullText.slice(0, charIndex + 1));
            setCharIndex(charIndex + 1);
          } else {
            setTimeout(() => setIsDeleting(true), pauseDuration);
          }
        }
      }, typingSpeed);

      return () => clearTimeout(typeEffect);
    }, [displayText, charIndex, isDeleting, fullText]);

  return (
    <div className="max-w-screen-xl mx-auto">
      <div className="md:flex space-x-4 justify-center py-2 space-y-4 mx-auto">
        <div className="backgroundImage">
          <div className="p-4 mask">
            <div className="grid">
              <h2
                className="text-3xl font-bold tracking-tight sm:text-4xl"
                style={{ color: "#3A636C" }}
              >
                <span className="text-[#3A636C] aboutUs">{displayText}</span>
              </h2>
              <p className="mt-6 text-lg leading-8 text-gray-600">
                We are your trusted partner for all essential services, from
                online applications, printing, and graphic design to website
                development and crypto training. Our team is dedicated to
                delivering fast, reliable, and affordable services with
                top-notch quality. You can conveniently order online and
                experience hassle-free, quick solutions. Trust us, test us—you
                won't regret it!
              </p>
              <Link target="_blank" to="/MoreAboutUs">
                <button
                  type="submit"
                  className="text-white px-6 py-3 mt-8  shadow-md bg-[#557a82] hover:text-customBlue hover:bg-white transition"
                >
                  Know More About Us
                </button>
              </Link>
            </div>
          </div>
        </div>

        {/* Slider for staff */}
        <Slider
          {...settings}
          className="w-3/4 sm:w-72 flex items-center justify-center"
        >
          {people.map((person) => (
            <div
              className="relative border-2 p-4 w-52 rounded-lg text-white shadow-md hover:shadow-lg transition-all duration-200 hover:bg-customBlue "
              key={person.name}
            >
              <center>
                <img
                  alt="Grand Shop Staff"
                  src={person.imageUrl}
                  className="h-16 w-16 rounded-full mb-4  items-center justify-center flex"
                />
              </center>
              <h3 className="text-base font-semibold leading-7 tracking-tight text-textColor  items-center justify-center flex">
                {person.name}
              </h3>
              <p className="text-sm font-semibold leading-6 text-customBlue items-center justify-center flex">
                {person.role}
              </p>

              {/* Add an overlay effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-gray-800 opacity-20 rounded-lg"></div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
